module.exports = __webpack_public_path__ + "img/sedona-21.3707fd78.png";